import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, Box, Button, IconButton, useTheme } from '@mui/material';
const ButtonTabs = ({ tabs, activeTab, onTabChange, maxWidth = '274px', size = 'medium', activeColor = 'success', variant = 'outlined', showIcons = true, useIconButton = false, noBackground = false }) => {
    const theme = useTheme();
    return (_jsx(Box, { sx: {
            display: 'flex',
            gap: 1,
            px: 1,
            py: '6px',
            maxWidth,
            borderRadius: 2,
            backgroundColor: !noBackground ? theme.palette.common.white : 'transparent',
            border: `1px solid ${theme.palette.primary.darker}`,
            overflowX: 'auto',
            whiteSpace: 'nowrap',
            minHeight: '48px'
        }, children: tabs.map(({ label, value, icon }) => useIconButton ? (_jsx(IconButton, { size: size, color: activeTab === value ? activeColor : 'default', onClick: () => onTabChange(value), sx: {
                border: activeTab === value && variant === 'outlined' ? 1 : 0,
                borderColor: activeTab === value ? theme.palette[activeColor].darker : 'transparent',
                backgroundColor: activeTab === value ? alpha(theme.palette[activeColor].main, 0.08) : 'transparent',
                color: activeTab === value && variant === 'contained'
                    ? theme.palette[activeColor].contrastText
                    : activeTab === value
                        ? theme.palette[activeColor].darker
                        : theme.palette.text.secondary,
                '&:hover': {
                    backgroundColor: activeTab === value
                        ? theme.palette[activeColor].light + '20'
                        : theme.palette.grey[100]
                },
                whiteSpace: 'nowrap'
            }, "aria-label": label, children: icon }, value)) : (_jsx(Button, { size: size, variant: activeTab === value ? variant : 'text', color: activeTab === value ? activeColor : 'inherit', startIcon: showIcons ? icon : undefined, onClick: () => onTabChange(value), sx: { whiteSpace: 'nowrap' }, children: label }, value))) }));
};
export default ButtonTabs;
